import React from 'react';
import styles from './customImageViewer.module.scss';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import VisualisationButton from '../VisualisationButton/VisualisationButton';
import { ReactComponent as ArrowBack } from 'icons/chevron-left.svg';
import { ReactComponent as ArrowForward } from 'icons/chevron-right.svg';
import { weakKey } from 'utils/objects';

export default function CustomImageViewer(props) {
  const { handleBack, handleNext, space, currentImage, onClose, handleSumbnailClick, images } =
    props;

  return (
    <div data-testid="CustomImageViewer" className={styles.image_viewer__wrapper}>
      <div className={styles.image_viewer__container}>
        <div className={styles.image_viewer__selected_img_container}>
          <VisualisationButton
            space={space}
            buttonClass={`${styles.image_viewer__close} ${styles.image_viewer__visualisation_button}`}
            iconClass={`${styles.image_viewer__visualisation_icon}`}
          />
          <IconButton
            data-testid="ImageViewerCloseBtn"
            onClick={onClose}
            className={styles.image_viewer__close}>
            <CloseIcon />
          </IconButton>
          <button
            data-testid="ImageViewerBackBtn"
            onClick={handleBack}
            className={styles.image_viewer__back}>
            <ArrowBack />
          </button>
          <button
            data-testid="ImageViewerNextBtn"
            onClick={handleNext}
            className={styles.image_viewer__forward}>
            <ArrowForward />
          </button>
          <div
            className={styles.image_viewer__selected_img}
            style={{ backgroundImage: `url(${currentImage})` }}
          />
        </div>
        <div className={styles.image_viewer__thumbnails}>
          {images.slice(0, 4).map((image, index) => (
            <div
              data-testid={`ImageViewerImage-${index}`}
              key={weakKey(image)}
              onClick={() => handleSumbnailClick(index)}
              className={`${styles.image_viewer__thumbnail} ${image.src === currentImage ? styles.image_viewer__thumbnail_active : ''
                }`}
              style={{ backgroundImage: `url(${image.src})` }}></div>
          ))}
        </div>
      </div>
      <div className={styles.image_viewer__summary_layout}></div>
    </div>
  );
}
